

export const frontMatter = {};
export const contentTitle = 'List';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-components-list-mdx-b54.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {SingleSelection} from "@intellij-platform/core/List/List.stories";
import {ExampleContext} from "@site/src/components/ExampleContext";
export const toc = [{
  "value": "SpeedSearchList",
  "id": "speedsearchlist",
  "level": 2
}, {
  "value": "ItemLayout",
  "id": "itemlayout",
  "level": 2
}, {
  "value": "ContextMenu",
  "id": "contextmenu",
  "level": 2
}, {
  "value": "Advanced use",
  "id": "advanced-use",
  "level": 2
}, {
  "value": "Custom list component with useList and useSpeedSearchList",
  "id": "custom-list-component-with-uselist-and-usespeedsearchlist",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "list",
        children: "List"
      })
    }), "\n", _jsx(_components.p, {
      children: "Used for showing a flat list of items with different selection modes. It's usually used in master-detail views, or for\na list of items with a single attribute. Here is some examples from JetBrains IDEs:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Settings -> Tools -> SSH Configurations"
        }), " (master-detail)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Settings -> Appearance & Behavior -> Scopes"
        }), " (master-detail)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Settings -> Editor -> General -> Console -> Exceptions"
        }), " (single attribute list of items)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Settings -> Editor -> File and Code Templates"
        }), " (master-detail)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Settings -> Editor -> Natural Languages"
        }), " (single attribute list of items)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Show Local History"
        }), " window (advanced layout)"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        metastring: "themed live",
        live: true,
        children: "<List selectionMode=\"multiple\" fillAvailableSpace>\n  <Item>Paco de lucia</Item>\n  <Divider />\n  <Item>Vicente Amigo</Item>\n  <Section title=\"Other\">\n    <Item>Gerardo Nunez</Item>\n    <Item>El Amir</Item>\n  </Section>\n</List>\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "speedsearchlist",
      children: "SpeedSearchList"
    }), "\n", _jsx(_components.p, {
      children: "TODO"
    }), "\n", _jsx(_components.h2, {
      id: "itemlayout",
      children: "ItemLayout"
    }), "\n", _jsxs(_components.p, {
      children: ["While you can render any custom content in ", _jsx(_components.code, {
        children: "Item"
      }), "s of a list, ", _jsx(_components.code, {
        children: "ItemLayout"
      }), " is a useful helper component implementing\nthe most common cases. Render different parts of an item, such as icon, text, etc. inside a ", _jsx(_components.code, {
        children: "ItemLayout"
      }), " and it handles\nthe layout, and the spacing between them. Some common parts that require a special style are implemented as components\naccessible on ", _jsx(_components.code, {
        children: "ItemLayout"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        metastring: "live themed",
        live: true,
        children: "<SpeedSearchList selectionMode=\"multiple\">\n  <Item textValue=\"jui\">\n    <ItemLayout>\n      <PlatformIcon icon=\"nodes/folder\" />\n      <HighlightedTextValue />\n      <ItemLayout.Hint>~/workspace/jui</ItemLayout.Hint>\n    </ItemLayout>\n  </Item>\n</SpeedSearchList>\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "contextmenu",
      children: "ContextMenu"
    }), "\n", _jsxs(_components.p, {
      children: ["In order to have context menu for list items, just wrap the list in a ", _jsx(_components.code, {
        children: "ContextMenuContainer"
      }), ". When the context menu\nis triggered on an item, the selection is also updated right before the context menu opens, so you can render the\ncontext menu based on the selected item(s)."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        metastring: "live themed noPadding",
        live: true,
        children: "function ListContextMenuExample() {\n  const [selectedKeys, setSelectedKeys] = useState(new Set());\n\n  return (\n    <ContextMenuContainer\n      renderMenu={() => {\n        const selectedKey = Array.from(selectedKeys)[0];\n        if (!selectedKey) {\n          return (\n            <Menu>\n              <Item>Nothing here</Item>\n            </Menu>\n          );\n        }\n        return (\n          <Menu>\n            <Item textValue={`Run '${selectedKey}'`}>\n              <MenuItemLayout\n                icon={<PlatformIcon icon=\"debugger/threadRunning.svg\" />}\n                content={`Run '${selectedKey}'`}\n                shortcut=\"⇧⏎\"\n              />\n            </Item>\n            <Item textValue={`Debug '${selectedKey}'`}>\n              <MenuItemLayout\n                icon={<PlatformIcon icon=\"actions/startDebugger.svg\" />}\n                content={`Debug '${selectedKey}'`}\n                shortcut=\"⌃⇧D\"\n              />\n            </Item>\n            <Item textValue={`Edit '${selectedKey}' Settings...`}>\n              <MenuItemLayout\n                icon={<PlatformIcon icon=\"actions/editSource.svg\" />}\n                content={`Edit '${selectedKey}' Settings...`}\n              />\n            </Item>\n            <Divider />\n            <Item textValue=\"Jump to source\">\n              <MenuItemLayout\n                icon={<PlatformIcon icon=\"actions/editSource.svg\" />}\n                content=\"Jump to source\"\n                shortcut=\"⌘↓\"\n              />\n            </Item>\n          </Menu>\n        );\n      }}\n    >\n      <List\n        selectionMode=\"single\"\n        selectedKeys={selectedKeys}\n        onSelectionChange={setSelectedKeys}\n      >\n        <Item key=\"start\">start</Item>\n        <Item key=\"build\">build</Item>\n        <Item key=\"test\">test</Item>\n        <Item key=\"deploy\">deploy</Item>\n      </List>\n    </ContextMenuContainer>\n  );\n}\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "advanced-use",
      children: "Advanced use"
    }), "\n", _jsx(_components.h3, {
      id: "custom-list-component-with-uselist-and-usespeedsearchlist",
      children: "Custom list component with useList and useSpeedSearchList"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

